<template>
  <!-- The carat mark: an emerald cut, in green.
       Green is the one hue in the app that only ever means currency, so it
       reads as money precisely because nothing else here is green. The cut is
       the one the stone is named after -- a rectangular step cut with
       truncated corners -- chosen over the round brilliant that every
       free-to-play wallet uses, so it reads as ours rather than borrowed.
       Facets are flat tonal steps: the white specular blob is what dated the
       gem it replaces, mimicking gloss on a surface that is otherwise matte. -->
  <svg
    class="carat-mark" :class="`is-${tone}`" :style="{ width: px, height: px }"
    viewBox="0 0 24 24" aria-hidden="true" focusable="false"
  >
    <path class="cm-girdle" d="M8.5 2 H15.5 L20 6.5 V17.5 L15.5 22 H8.5 L4 17.5 V6.5 Z" />
    <path class="cm-step" d="M9.4 4.2 H14.6 L17.8 7.4 V16.6 L14.6 19.8 H9.4 L6.2 16.6 V7.4 Z" />
    <path class="cm-table" d="M10.3 6.4 H13.7 L15.6 8.3 V15.7 L13.7 17.6 H10.3 L8.4 15.7 V8.3 Z" />
    <path class="cm-crown" d="M10.3 6.4 H13.7 L15.6 8.3 H8.4 Z" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  /** Rendered size in px. The cut holds its read down to about 12. */
  size: { type: [Number, String], default: 16 },
  /**
   * `bright` for the app's dark violet grounds.
   * `ink`    for light grounds -- chiefly the gold act button, where the
   *          bright stone disappears into the gradient.
   */
  tone: { type: String, default: 'bright' },
})

const px = computed(() => `${parseFloat(props.size)}px`)
</script>

<style scoped>
.carat-mark { display: inline-block; vertical-align: -0.14em; flex: 0 0 auto; }

.is-bright .cm-girdle { fill: #16644a; }
.is-bright .cm-step   { fill: #1e8a63; }
.is-bright .cm-table  { fill: #34c08c; }
.is-bright .cm-crown  { fill: #7fe0bc; opacity: 0.55; }

.is-ink .cm-girdle { fill: #0e3a2b; }
.is-ink .cm-step   { fill: #14573f; }
.is-ink .cm-table  { fill: #1e8a63; }
.is-ink .cm-crown  { fill: #34c08c; opacity: 0.7; }
</style>
